import { model } from "../firebaseConfig";

export const run = async (base64Image) => {
  const rawBase64 = base64Image.split(",")[1];
  // Provide a prompt that contains text
  const image1 = {
    inlineData: {
      mimeType: "image/png",
      data: rawBase64,
    },
  };

  const req = {
    contents: [
      {
        role: "user",
        parts: [
          {
            text: `Turn the the part of the image highlighted with a selection box into text.  After that translate that into English.  Tutor me on what each sound the characters make and what each word means.`,
          },
          image1,
        ],
      },
    ],
  };

  const result = await model.generateContentStream(req);
  let fullText = "";

  for await (const chunk of result.stream) {
    const chunkText = chunk.text();
    fullText += chunkText; // Append each chunk to the accumulator
  }

  //console.log(fullText); // Output the complete text
  return fullText; // Return the complete text after the loop
};
